import React from 'react';
import LandingSection from 'containers/artPage/artLanding';
import Footer from 'containers/footer';

import {useDataValue} from 'globals/contexts/dataContext';

import './artPage.css';

const ArtPage = () => {
  const [{content, currentLanguage}] = useDataValue();
  const pageContent = content['content'][currentLanguage]['pages']['art'];
  return <div id="art" className="page">
    <LandingSection content={pageContent['landing']} />
    <Footer />
  </div>;
};

export default ArtPage;